import React from 'react';
import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer';
import moment from 'moment';
import Tw_Cen_MT from '../../../../componentes/font/Tw_Cen_MT/TCM_____.TTF';
import Tw_Cen_MT_Negrita from '../../../../componentes/font/Tw_Cen_MT/TCB_____.TTF';
import { NegocioConfig } from "../../../../configuracion/Empresa";
import { formatoMoneda } from '../../../../configuracion/validaciones';
Font.register({ family: 'Tw_Cen_MT', src: Tw_Cen_MT });
Font.register({ family: 'Tw_Cen_MT_Negrita', src: Tw_Cen_MT_Negrita });

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Tw_Cen_MT',
        fontSize: 10,
        paddingTop: 40,
        paddingBottom: 50,
        paddingHorizontal: 60,
        backgroundColor: '#ffffff',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: 5,
        paddingBottom: 0,
        //borderBottomWidth: 1,
        //borderBottomColor: '#333',//'#E0E0E0',
    },
    companyInfoLeft: {
        flexGrow: 1,
        textAlign: 'left',
    },
    companyName: {
        fontFamily: 'Tw_Cen_MT_Negrita',
        fontSize: 16,
        color: '#333',
        marginBottom: 3,
    },
    companyAddress: {
        fontSize: 9,
        color: '#666',
        marginBottom: 2,
    },
    companyContact: {
        fontSize: 9,
        color: '#666',
    },
    logoContainer: {
        width: 100,
        height: 100,
        marginLeft: 20,
        marginTop: -10
    },
    logo: {
        width: 100,
        height: 100,
        objectFit: 'cover',
        alignSelf: 'center',
        marginBottom: 2,
        borderRadius: 15,
        overflow: 'hidden',
    },
    titleSection: {
        textAlign: 'center',
        marginBottom: 5,
    },
    title: {
        fontSize: 16,
        fontFamily: 'Tw_Cen_MT_Negrita',
        color: '#222',
        letterSpacing: 1,
        textTransform: 'uppercase',
        marginTop: 15,
    },
    subtitle: {
        fontSize: 12,
        color: '#555',
        marginTop: 5,
    },
    infoGrid: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 5,
    },
    infoColumn: {
        width: '100%',//'48%',
    },
    infoLabel: {
        fontFamily: 'Tw_Cen_MT_Negrita',
        fontSize: 10,
        color: '#444',
        marginBottom: 3,
    },
    infoText: {
        fontSize: 10,
        marginBottom: 7,
        color: '#666',
    },
    sectionTitle: {
        fontFamily: 'Tw_Cen_MT_Negrita',
        fontSize: 12,
        marginBottom: 10,
        paddingBottom: 3,
        borderBottomWidth: 1.5,
        borderBottomColor: '#D0D0D0',
        color: '#333',
        textTransform: 'uppercase',
    },
    table: {
        width: '100%',
        marginBottom: 10,
        borderCollapse: 'collapse',
    },
    tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#F5F5F5',
        borderBottomWidth: 1,
        borderBottomColor: '#E0E0E0',
        paddingVertical: 8,
        fontFamily: 'Tw_Cen_MT_Negrita',
        fontSize: 10,
        color: '#333',
    },
    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 0.5,
        borderBottomColor: '#F0F0F0',
        paddingVertical: 6,
    },
    colDescription: {
        width: '45%',
        paddingLeft: 5,
    },
    colQty: {
        width: '15%',
        textAlign: 'center',
    },
    colPrice: {
        width: '20%',
        textAlign: 'right',
        paddingRight: 5,
    },
    colTotal: {
        width: '20%',
        textAlign: 'right',
        paddingRight: 5,
    },
    itemText: {
        fontSize: 10,
        color: '#555',
    },
    totalsContainer: {
        width: '40%',
        alignSelf: 'flex-end',
        borderTopWidth: 1.5,
        borderTopColor: '#E0E0E0',
        paddingTop: 10,
    },
    totalsRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 5,
    },
    totalLabel: {
        fontSize: 10,
        color: '#555',
    },
    totalValue: {
        fontSize: 10,
        fontFamily: 'Tw_Cen_MT_Negrita',
        color: '#333',
    },
    grandTotalRow: {
        marginTop: 10,
        paddingTop: 8,
        borderTopWidth: 1,
        borderTopColor: '#D0D0D0',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    grandTotalLabel: {
        fontFamily: 'Tw_Cen_MT_Negrita',
        fontSize: 14,
        color: '#000',
    },
    grandTotalValue: {
        fontFamily: 'Tw_Cen_MT_Negrita',
        fontSize: 14,
        color: '#000',
    },
    notesSection: {
        marginTop: 10,
        paddingTop: 15,
        borderTopWidth: 1,
        borderTopColor: '#E0E0E0',
    },
    notesText: {
        fontSize: 9,
        lineHeight: 1.5,
        color: '#666',
    },
    footer: {
        position: 'absolute',
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: 8,
        color: '#888',
        paddingHorizontal: 60,
    },
    listaEmpresas: {
        marginTop: 3,
        marginBottom: 7,
    },
    nombreEmpresa: {
        fontSize: 10,
        color: '#666',
        marginBottom: 2,
    },
});

const ReporteNormalPedido = ({ pedido }) => {
    if (!pedido) {
        return (
            <Document>
                <Page style={styles.page}>
                    <Text>No hay datos de pedido disponibles.</Text>
                </Page>
            </Document>
        );
    }
    const nombreCliente = pedido.nombreCliente || pedido.Cliente?.nombreCompleto || 'N/A';
    const nombreEmpleado = pedido.nombreEmpleado || pedido.Empleado?.nombreCompleto || 'N/A';
    return (
        <Document>
            <Page size="LETTER" style={styles.page}>
                {/* Header */}
                <View style={styles.header}>
                    <View style={styles.companyInfoLeft}>
                        <Text style={styles.companyName}>{NegocioConfig.nombre}</Text>
                        <Text style={styles.companyAddress}>{NegocioConfig.direccion}</Text>
                        <Text style={styles.companyAddress}>RTN: {NegocioConfig.rtn} Email: {NegocioConfig.correo}</Text>
                        <Text style={styles.companyAddress}>Tel: {NegocioConfig.telefono}</Text>
                        <Text style={styles.title}>PEDIDO N° {pedido.id}</Text>
                    </View>
                    {NegocioConfig.logo && (
                        <View style={styles.logoContainer}>
                            <Image style={styles.logo} src={NegocioConfig.logo} />
                        </View>
                    )}
                </View>

                {/* Title Section */}
                
                    <View style={styles.infoGrid}>
                        <View style={styles.infoColumn}>
                            <Text style={styles.infoLabel}>Fecha de Pedido:</Text>
                            <Text style={styles.infoText}>{moment(pedido.fecha).format("DD/MM/YYYY HH:mm")}</Text>
                        </View>
                        <View style={styles.infoColumn}>
                            <Text style={styles.infoLabel}>Atendido Por:</Text>
                            <Text style={styles.infoText}>{nombreEmpleado}</Text>
                        </View>
                        <View style={styles.infoColumn}>
                            <Text style={styles.infoLabel}>Estado:</Text>
                            <Text style={styles.infoText}>{pedido.estado}</Text>
                        </View>
                    </View>
                

                {/* Order & Client Info */}
                <View style={styles.infoGrid}>
                    <View style={styles.infoColumn}>
                        <Text style={styles.sectionTitle}>INFORMACIÓN DEL CLIENTE</Text>
                        <Text style={styles.infoLabel}>Nombre del Cliente:</Text>
                        <Text style={styles.infoText}>{nombreCliente}</Text>
                        {pedido.Cliente?.rtn && (
                            <>
                                <Text style={styles.infoLabel}>RTN del Cliente:</Text>
                                <Text style={styles.infoText}>{pedido.Cliente.rtn}</Text>
                            </>
                        )}
                        {/* Se agrega la sección de empresas si existen */}
                        {pedido.Cliente?.ClienteEmpresas?.length > 0 && (
                            <>
                                <Text style={styles.infoLabel}>Nombre de la Empresa:</Text>
                                <View style={styles.listaEmpresas}>
                                    {pedido.Cliente.ClienteEmpresas.map(empresa => (
                                        <Text key={empresa.id} style={styles.nombreEmpresa}>- {empresa.nombre}</Text>
                                    ))}
                                </View>
                            </>
                        )}
                        {/* Puedes añadir más campos del cliente si están disponibles */}
                    </View>
                </View>

                {/* Products Table */}
                <View style={styles.sectionTitle}>DETALLE DE PRODUCTOS / SERVICIOS</View>
                <View style={styles.table}>
                    <View style={styles.tableHeader}>
                        <Text style={styles.colDescription}>DESCRIPCIÓN</Text>
                        <Text style={styles.colQty}>CANTIDAD</Text>
                        <Text style={styles.colPrice}>PRECIO UNITARIO</Text>
                        <Text style={styles.colTotal}>SUBTOTAL</Text>
                    </View>
                    {/* Se mapea pedidoDetalles en lugar de cotizacionDetalles */}
                    {pedido.pedidoDetalles?.map((item, index) => (
                        <View key={item.id} style={styles.tableRow}>
                            <Text style={[styles.itemText, styles.colDescription]}>{item.producto?.nombre}</Text>
                            <Text style={[styles.itemText, styles.colQty]}>{item.cantidad}</Text>
                            {/* item.producto.precioConImpuesto se utiliza si el objeto ya viene procesado con el desglose del precio total */}
                            <Text style={[styles.itemText, styles.colPrice]}>{formatoMoneda(item.producto?.precioConImpuesto || item.precio)}</Text>
                            <Text style={[styles.itemText, styles.colTotal]}>{formatoMoneda(parseFloat(item.cantidad) * parseFloat(item.producto?.precioConImpuesto || item.precio))}</Text>
                        </View>
                    ))}
                </View>

                {/* Totals */}
                <View style={styles.totalsContainer}>
                    <View style={styles.totalsRow}>
                        <Text style={styles.totalLabel}>Subtotal:</Text>
                        <Text style={styles.totalValue}>{formatoMoneda(pedido.subtotal)}</Text>
                    </View>
                    <View style={styles.totalsRow}>
                        <Text style={styles.totalLabel}>ISV:</Text>
                        <Text style={styles.totalValue}>{formatoMoneda(pedido.isv)}</Text>
                    </View>
                    <View style={styles.grandTotalRow}>
                        <Text style={styles.grandTotalLabel}>TOTAL:</Text>
                        <Text style={styles.grandTotalValue}>{formatoMoneda(pedido.total)}</Text>
                    </View>
                </View>

                {/* Notes */}
                {pedido.notas && pedido.notas.trim() !== "" && (
                    <View style={styles.notesSection}>
                        <Text style={styles.sectionTitle}>NOTAS ADICIONALES</Text>
                        <Text style={styles.notesText}>{pedido.notas}</Text>
                    </View>
                )}

                {/* Footer */}
                <Text style={styles.footer} fixed>
                    Gracias por su pedido. Para cualquier consulta, por favor contáctenos.
                </Text>
            </Page>
        </Document>
    );
};

export default ReporteNormalPedido;